import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-student-form',
  templateUrl: './student-form.component.html',
  styleUrls: ['./student-form.component.scss']
})
export class StudentFormComponent implements OnInit {
  StudentForm: FormGroup;
  studentArr: any;
  constructor(
    private fb: FormBuilder, 
    public router: Router,
    ) { }

  value: any = '';
  value1: any = '';
  value2: any = '';
  x = sessionStorage.getItem('arr');
  y:any = '';
  z:any = '';
  ngOnInit(): void {

    this.StudentForm = this.fb.group({
      SName: new FormControl ('', [Validators.required]),
      SAge: new FormControl ('', [Validators.required]),
      SGender: new FormControl ('', [Validators.required]),
      
    });
    
   this.studentArr = JSON.parse(sessionStorage.getItem('arr1'));
   this.studentArr.forEach(element => {
    if(element.Visible){
      this.StudentForm.addControl(element.form, new FormControl('', Validators.required));
    }
  })
   
   
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  back(){
    this.redirect('admin-setting');
  }
  add(){
  }

}
